import { Component } from "@angular/core";

import { NgOptimizedImage } from "@angular/common";

@Component({
    selector: "app-auth-hero",
    standalone: true,
    imports: [NgOptimizedImage],
    templateUrl: "./auth-hero.component.html",
    styleUrls: ["./auth-hero.component.scss"],
})
export class AuthHeroComponent {}
